/* Temporary, opt-in cart diagnostics. Remove after investigation. */
(function () {
  'use strict';
  var KEY = 'ld_cart_diagnostics_v1';
  var TTL = 60 * 60 * 1000;
  var state, params = new URLSearchParams(location.search);
  try {
    state = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (params.get('cart_diag') === '0') {
      sessionStorage.removeItem(KEY);
      return;
    }
    if (params.get('cart_diag') === '1' && (!state || Date.now() > state.expires)) {
      state = { version: 1, started: new Date().toISOString(), expires: Date.now() + TTL, events: [] };
    }
    if (!state || Date.now() > state.expires) return;
  } catch (_) { return; }
  if (window.__ldCartDiagnostics) return;
  window.__ldCartDiagnostics = true;

  var stopped = false, serial = 0, countNode;
  var pageId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  function safeURL(value) {
    try { var u = new URL(value, location.href); return u.origin + u.pathname; }
    catch (_) { return '[unreadable URL]'; }
  }
  function cartURL(value) {
    try {
      return /\/cart(?:\/(?:add|change|update|clear))?(?:\.js)?\/?$/.test(new URL(value, location.href).pathname);
    } catch (_) { return false; }
  }
  function redact(value, depth) {
    if (depth > 6) return '[depth limit]';
    if (typeof value === 'string') return value.slice(0, 1500);
    if (value === null || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.slice(0, 40).map(function (v) { return redact(v, depth + 1); });
    var out = {};
    Object.keys(value).slice(0, 100).forEach(function (key) {
      out[key] = /email|phone|address|token|cookie|password|authorization|customer|note|message|upload|file|姓名|电话|地址|邮箱/i.test(key)
        ? '[redacted]' : redact(value[key], depth + 1);
    });
    return out;
  }
  function requestBody(body) {
    try {
      if (typeof body === 'string') {
        try { return redact(JSON.parse(body), 0); }
        catch (_) { return requestBody(new URLSearchParams(body)); }
      }
      if (body instanceof FormData || body instanceof URLSearchParams) {
        var entries = [];
        body.forEach(function (value, key) {
          if (entries.length >= 150) return;
          var obj = {};
          obj[key] = typeof value === 'string' ? value : '[file omitted]';
          entries.push(redact(obj, 0));
        });
        return entries;
      }
      return body == null ? null : '[body type not captured]';
    } catch (_) { return '[body unavailable]'; }
  }
  function responseBody(text) {
    try {
      var data = JSON.parse(text), out = {};
      // Retain diagnostic fields, not cart tokens, customer details or full HTML.
      ['status', 'description', 'message', 'errors', 'id', 'variant_id', 'quantity', 'item_count'].forEach(function (key) {
        if (data[key] !== undefined) out[key] = redact(data[key], 0);
      });
      if (Array.isArray(data.items)) out.items = data.items.slice(0, 40).map(function (item) {
        return { id: item.id, variant_id: item.variant_id, quantity: item.quantity };
      });
      return out;
    } catch (_) { return { format: 'non-JSON', length: text.length, preview: text.slice(0, 300) }; }
  }
  function record(type, detail) {
    try {
      if (stopped || Date.now() > state.expires) return;
      state.events.push({ time: new Date().toISOString(), pageId: pageId, page: location.pathname, type: type, detail: detail });
      while (state.events.length > 180 || JSON.stringify(state).length > 220000) state.events.shift();
      sessionStorage.setItem(KEY, JSON.stringify(state));
      if (countNode) countNode.textContent = '诊断中 · ' + state.events.length + ' 条';
    } catch (_) {
      if (countNode) countNode.textContent = '诊断存储失败，请立即导出';
    }
  }
  function errorInfo(error) {
    return { name: error && error.name, message: String(error && error.message || error).slice(0, 1500), stack: String(error && error.stack || '').slice(0, 3000) };
  }
  record('page-open', { url: safeURL(location.href), userAgent: navigator.userAgent, online: navigator.onLine });

  var originalFetch = window.fetch;
  if (originalFetch) window.fetch = function (input, init) {
    var url, tracked = false, id, started = Date.now();
    try {
      url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
      tracked = cartURL(url) && !stopped && Date.now() <= state.expires;
      if (tracked) {
        id = pageId + '-' + (++serial);
        record('fetch-start', { id: id, url: safeURL(url), method: init && init.method || input.method || 'GET',
          body: init && 'body' in init ? requestBody(init.body) : (typeof input === 'object' && input.body ? '[Request body not read]' : null),
          stack: String(new Error().stack || '').slice(0, 3000) });
      }
    } catch (_) {}
    var promise;
    try { promise = originalFetch.apply(this, arguments); }
    catch (error) { if (tracked) record('fetch-throw', { id: id, error: errorInfo(error) }); throw error; }
    if (tracked) {
      // Observe a separate branch; return the original promise and never consume its response.
      promise.then(function (response) {
        record('fetch-response', { id: id, status: response.status, ok: response.ok, redirected: response.redirected,
          url: safeURL(response.url || url), elapsedMs: Date.now() - started });
        try {
          response.clone().text().then(function (text) {
            record('fetch-body', { id: id, response: responseBody(text) });
          }, function (error) { record('fetch-body-error', { id: id, error: errorInfo(error) }); }).catch(function () {});
        } catch (error) { record('fetch-clone-error', { id: id, error: errorInfo(error) }); }
      }, function (error) {
        record('fetch-failed', { id: id, elapsedMs: Date.now() - started, online: navigator.onLine, error: errorInfo(error) });
      }).catch(function () {});
    }
    return promise;
  };

  var xhrInfo = new WeakMap();
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    var result = originalOpen.apply(this, arguments);
    try { xhrInfo.set(this, { method: method, url: String(url) }); } catch (_) {}
    return result;
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, info = xhrInfo.get(xhr), started = Date.now(), handlers = [];
    if (info && cartURL(info.url) && !stopped && Date.now() <= state.expires) {
      var id = pageId + '-' + (++serial);
      record('xhr-start', { id: id, method: info.method, url: safeURL(info.url), body: requestBody(body), stack: String(new Error().stack || '').slice(0, 3000) });
      ['error', 'abort', 'timeout', 'loadend'].forEach(function (event) {
        var handler = function () {
          var detail = { id: id, status: xhr.status, elapsedMs: Date.now() - started };
          try {
            if (event === 'loadend') {
              if (!xhr.responseType || xhr.responseType === 'text') detail.response = responseBody(xhr.responseText);
              else if (xhr.responseType === 'json') detail.response = responseBody(JSON.stringify(xhr.response));
            }
          } catch (_) {}
          record('xhr-' + event, detail);
          if (event === 'loadend') handlers.forEach(function (pair) { xhr.removeEventListener(pair[0], pair[1]); });
        };
        handlers.push([event, handler]);
        xhr.addEventListener(event, handler);
      });
    }
    try { return originalSend.apply(this, arguments); }
    catch (error) {
      handlers.forEach(function (pair) { xhr.removeEventListener(pair[0], pair[1]); });
      if (id) record('xhr-throw', { id: id, error: errorInfo(error) });
      throw error;
    }
  };
  document.addEventListener('click', function (event) {
    try {
      var el = event.target.closest('button, a, input[type="submit"], [role="button"]');
      if (!el || el.closest('#ld-cart-diagnostics')) return;
      record('click', { tag: el.tagName, id: el.id, text: (el.innerText || el.value || '').trim().slice(0, 100), href: el.href ? safeURL(el.href) : null });
    } catch (_) {}
  }, true);
  document.addEventListener('submit', function (event) {
    record('form-submit', { action: safeURL(event.target.action), method: event.target.method, preventedAtCapture: event.defaultPrevented });
  }, true);
  ['pagehide', 'pageshow', 'online', 'offline'].forEach(function (name) {
    window.addEventListener(name, function (event) { record(name, { persisted: event.persisted, online: navigator.onLine }); });
  });
  document.addEventListener('visibilitychange', function () { record('visibility', { state: document.visibilityState }); });
  window.addEventListener('error', function (event) { if (event.error) record('script-error', errorInfo(event.error)); });
  window.addEventListener('unhandledrejection', function (event) { record('unhandled-rejection', errorInfo(event.reason)); });

  function ui() {
    var panel = document.createElement('details');
    panel.id = 'ld-cart-diagnostics';
    panel.style.cssText = 'position:fixed;top:8px;right:8px;z-index:2147483647;background:#fff;color:#111;border:1px solid #555;border-radius:8px;padding:8px;font:13px/1.5 sans-serif;max-width:260px;box-shadow:0 2px 8px #0003;';
    countNode = document.createElement('summary');
    countNode.textContent = '诊断中 · ' + state.events.length + ' 条';
    panel.appendChild(countNode);
    function button(label, callback) {
      var el = document.createElement('button');
      el.type = 'button'; el.textContent = label;
      el.style.cssText = 'display:block;margin:8px 0;padding:8px;background:#eee;color:#111;border:1px solid #aaa;font-size:14px;';
      el.addEventListener('click', callback); panel.appendChild(el);
    }
    button('标记：刚刚出现报错', function () { record('user-error-marker', {}); });
    button('导出记录', function () {
      record('export', {});
      var blob = new Blob([JSON.stringify(state, null, 2)], { type: 'application/json' });
      var url = URL.createObjectURL(blob), link = document.createElement('a');
      link.href = url; link.download = 'cart-diagnostics-' + Date.now() + '.json';
      panel.appendChild(link); link.click(); link.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
    });
    button('复制记录（导出失败时）', function () {
      var area = panel.querySelector('textarea') || document.createElement('textarea');
      area.readOnly = true; area.value = JSON.stringify(state, null, 2);
      area.style.cssText = 'width:240px;height:120px;font-size:16px;'; panel.appendChild(area); area.select();
    });
    button('停止并清除记录', function () {
      stopped = true;
      try {
        sessionStorage.removeItem(KEY);
        var url = new URL(location.href); url.searchParams.set('cart_diag', '0');
        history.replaceState(history.state, '', url.href);
      } catch (_) {}
      panel.remove(); location.reload();
    });
    document.body.appendChild(panel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ui, { once: true });
  else ui();
})();
